import $ from "jquery";

const commonIssue = () => {
  const init = () => {
    foldCommonIssue();
  };

  const foldCommonIssue = () => {
    const el = {
      listCS: ".js-common_lists--cs ul.elementor-icon-list-items > li",
      listHC: ".js-common_lists--hc ul.elementor-icon-list-items > li",
      button: "#js-managementIssueShowMoreButton ",
    };

    if ($(el.button).length === 0) return;

    $(el.listCS).slice(4).hide();
    $(el.listHC).slice(4).hide();

    $(document).on("click", el.button, function (e) {
      e.preventDefault();
      $(el.listCS).slice(4).toggle(300);
      $(el.listHC).slice(4).toggle(300);
    });
  };

  init();
};

try {
  commonIssue();
} catch (error) {
  console.error(error);
}
